
import { Component, Prop, Vue } from 'vue-property-decorator'
import {copyToClipboard} from 'quasar'

import OxxoModel from '../models/Oxxo'

import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EPaymentInfo,
  },
})
export default class Oxxo extends Vue {
  @Prop({ required: true }) readonly oxxo!: OxxoModel
}
